export default __webpack_public_path__ + "static/media/3.a7c3b53f.png";